<ng-container
  *ngLet="{
    yScale: yScale | async,
    yTicks: yTicks | async,
    xScale: xScale | async,
    xMinorTicks: xMinorTicks | async,
    xMajorTicks: xMajorTicks | async,
    seriesPath: seriesPath | async,
    seriesMarkers: seriesMarkers | async
  } as values"
>
  <svg
    *ngIf="!(empty | async); else zeroState"
    xmlns="http://www.w3.org/2000/svg"
    (clientSize)="svgSize.next($event)"
  >
    <ng-container *ngIf="values.xScale && values.yScale">
      <g *ngFor="let tick of values.xMajorTicks">
        <rect
          class="tick"
          [attr.x]="values.xScale(tick.value)"
          y="0"
          width="1"
          [attr.height]="values.yScale(0)"
        ></rect>
        <text
          class="x-major-tick-label"
          [attr.x]="values.xScale(tick.value)"
          [attr.y]="values.yScale(0)"
          dx="4"
          dy="-4"
        >
          {{ tick.label }}
        </text>
      </g>
      <g *ngFor="let tick of values.xMinorTicks">
        <text
          class="x-minor-tick-label"
          [attr.x]="values.xScale(tick.value)"
          [attr.y]="values.yScale(0)"
          text-anchor="middle"
          dominant-baseline="hanging"
          dy="8"
        >
          {{ tick.label }}
          <title>{{ tick.value | rivDate: 'mediumDate' }}</title>
        </text>
      </g>
      <g *ngFor="let tick of values.yTicks">
        <rect
          class="tick"
          x="0"
          [attr.y]="values.yScale(tick)"
          width="100%"
          height="1"
        ></rect>
        <text class="y-tick-label" x="0" [attr.y]="values.yScale(tick)" dy="-4">
          {{ (valueFormatter | async)!(tick) }}
        </text>
      </g>
    </ng-container>
    <path
      class="data path"
      [attr.d]="values.seriesPath"
      stroke-linecap="round"
      fill="none"
      stroke-width="2"
    ></path>
    <circle
      *ngFor="let marker of values.seriesMarkers"
      class="data marker"
      [attr.cx]="marker.x"
      [attr.cy]="marker.y"
      r="3"
      stroke-width="2"
    >
      <title>{{ marker.label }}</title>
    </circle>
  </svg>
</ng-container>

<ng-template #zeroState>
  <div class="zero-state">No data to display.</div>
</ng-template>
